import { render, staticRenderFns } from "./Editnamelist.vue?vue&type=template&id=7ec56fee"
import script from "./Editnamelist.vue?vue&type=script&lang=js"
export * from "./Editnamelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports